<div class="territory-map-container">
    <div class="controls">
        <!-- Country Selection -->
        <p-card header="Country Selection" styleClass="mb-3">
            <div class="col-12">
                <label for="countrySelect" class="font-medium text-gray-800 mb-1">
                    <i class="pi pi-globe mr-2"></i>Select Country
                </label>
                <p-select 
                    id="countrySelect"
                    [(ngModel)]="selectedCountry"
                    [options]="countries"
                    optionLabel="name"
                    placeholder="Choose a country to restrict map area" i18n-placeholder
                    (onChange)="onCountryChange()"
                    class="w-full" />
                <small class="text-gray-500 text-sm mt-1">
                    <i class="pi pi-info-circle mr-1"></i>
                    Selecting a country will restrict map movement and polygon drawing to that area.
                </small>
                <div *ngIf="selectedCountry" class="mt-3">
                    <p-button appGlobalLoadingDisable 
                        label="Show Full Country Area" 
                        icon="pi pi-expand" 
                        severity="info"
                        size="small"
                        (onClick)="showFullCountry()" />
                </div>
            </div>
        </p-card>

        <!-- Map Controls -->
        <p-card header="Map Controls" styleClass="mb-3">
            <div class="flex flex-column gap-3">
                <!-- Drawing Instructions -->
                <!-- <div class="col-12 p-3 bg-blue-50 border-round border-1 border-blue-200">
                    <div class="flex align-items-center gap-2 mb-2">
                        <i class="pi pi-draw-polygon text-blue-600"></i>
                        <span class="font-medium text-blue-800">Drawing Instructions</span>
                    </div>
                    <div class="text-sm text-blue-700 flex flex-column gap-1">
                        <div><strong>1.</strong> Select a country first to restrict the drawing area</div>
                        <div><strong>2.</strong> Look for the <i class="pi pi-draw-polygon"></i> polygon icon above the map</div>
                        <div><strong>3.</strong> Click the polygon icon to start drawing mode</div>
                        <div><strong>4.</strong> Click on the map to create polygon points</div>
                        <div><strong>5.</strong> Double-click to complete the polygon</div>
                    </div>
                </div> -->

                <div class="col-12">
                    <label for="mapTypeSelect" class="font-medium text-gray-800 mb-1">
                        <i class="pi pi-image mr-2"></i>Map Type
                    </label>
                    <p-select 
                        id="mapTypeSelect"
                        [(ngModel)]="selectedMapType"
                        [options]="mapTypes"
                        optionLabel="name"
                        optionValue="value"
                        placeholder="Select map type" i18n-placeholder
                        (onChange)="onMapTypeChange()"
                        class="w-full" />
                </div>
                
                <div class="col-12">
                    <label class="font-medium text-gray-800 mb-1">
                        <i class="pi pi-pencil mr-2"></i>Edit Mode
                    </label>
                    <div class="flex items-center gap-3">
                        <p-toggle-button 
                            [(ngModel)]="editMode"
                            onLabel="EditModeON"
                            offLabel="Edit Mode OFF"
                            (onChange)="toggleEditMode()"
                            [disabled]="polygons.length === 0" />
                        
                        <div *ngIf="editMode" class="flex align-items-center">
                            <input 
                                type="checkbox" 
                                id="editAllPolygons"
                                [(ngModel)]="editAllPolygons"
                                class="w-4 h-4 mr-2" />
                            <label for="editAllPolygons" class="text-sm text-gray-700">
                                Edit all polygons
                            </label>
                        </div>
                        
                        <div *ngIf="editMode && hasEditingPolygons()" class="mt-2">
                            <p-button appGlobalLoadingDisable 
                                label="Stop Editing All" 
                                icon="pi pi-stop" 
                                severity="danger" 
                                size="small"
                                (onClick)="stopEditingAll()" />
                        </div>
                    </div>
                    <small class="text-gray-500 text-sm mt-1">
                        <i class="pi pi-info-circle mr-1"></i>
                        Enable edit mode to modify existing polygons. Choose whether to edit all or selected polygons only.
                    </small>
                </div>
            </div>
        </p-card>

        <!-- Search Controls -->
        <p-card header="Search Controls" styleClass="mb-3">
            <div class="">
                <div class="col-12 mb-3">
                    <label for="placeInput" class="font-medium text-gray-800 mb-1">
                        <i class="pi pi-building mr-2"></i>Business/Place Search
                    </label>
                    <input 
                        #placeInput 
                        id="placeInput"
                        type="text"
                        pInputText
                        placeholder="Search business / place (autocomplete)" i18n-placeholder
                        class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100" />
                </div>

                <div class="col-12 mb-3">
                    <label for="regionInput" class="font-medium text-gray-800 mb-1">
                        <i class="pi pi-map-marker mr-2"></i>Region/City Search
                    </label>
                    <input 
                        #regionInput 
                        id="regionInput"
                        type="text"
                        pInputText
                        placeholder="Search region / city / area (regions) (autocomplete)" i18n-placeholder
                        class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100" />
                    <small class="text-gray-500 text-sm mt-1">
                        <i class="pi pi-info-circle mr-1"></i>
                        Selecting a region will create a boundary polygon.
                    </small>
                </div>

                <div class="col-12">
                    <label for="locationInput" class="font-medium text-gray-800 mb-1">
                        <i class="pi pi-search mr-2"></i>Location Check
                    </label>
                    <input 
                        #locationInput 
                        id="locationInput"
                        type="text"
                        pInputText
                        placeholder="Search location to check if it's inside polygons" i18n-placeholder
                        class="w-full rounded-lg border border-gray-300 text-base transition-all duration-200 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100" />
                    <small class="text-gray-500 text-sm mt-1">
                        <i class="pi pi-info-circle mr-1"></i>
                        Check if a location is inside any drawn polygon.
                        <span *ngIf="selectedCountry" class="text-blue-600 font-medium">
                            Only locations within {{selectedCountry.name}} are allowed.
                        </span>
                    </small>
                </div>
            </div>
        </p-card>

        <!-- Action Buttons -->
        <p-card header="Actions" styleClass="mb-3">
            <div class="flex flex-wrap gap-2">
                <p-button appGlobalLoadingDisable 
                    label="Export/Save Polygons" 
                    icon="pi pi-download" 
                    severity="success"
                    (onClick)="saveAll()" />
                <p-button appGlobalLoadingDisable 
                    label="Clear Location Check" 
                    icon="pi pi-times" 
                    severity="secondary"
                    (onClick)="clearLocationCheck()" />
                <p-button appGlobalLoadingDisable 
                    label="Refresh Overlap Detection" 
                    icon="pi pi-refresh" 
                    severity="info"
                    (onClick)="refreshOverlapDetection()" />
                <p-button appGlobalLoadingDisable 
                    label="Check Available Areas" 
                    icon="pi pi-search" 
                    severity="info"
                    (onClick)="status='Available drawing areas: ' + getAvailableDrawingAreas().length + ' regions'" />
                <p-button appGlobalLoadingDisable 
                    label="Help" 
                    icon="pi pi-question-circle" 
                    severity="info"
                    (onClick)="status='Toggle drawing in map. Use drawing control on map. Select a country first to restrict the area. Edit mode prevents overlaps.'" />
            </div>
        </p-card>

        <!-- Status -->
        <p-card header="Status" styleClass="mb-3">
            <p-message 
                [severity]="getStatusSeverity()" 
                [text]="status" 
                styleClass="w-full" />
            
            <!-- Country Restriction Info -->
            <div *ngIf="selectedCountry" class="mt-3 p-3 bg-blue-50 border-round border-1 border-blue-200">
                <div class="flex items-center gap-2 mb-2">
                    <i class="pi pi-shield text-blue-600"></i>
                    <span class="font-medium text-blue-800">Country Restrictions Active</span>
                </div>
                <div class="text-sm text-blue-700 space-y-1">
                    <div><strong>Country:</strong> {{selectedCountry.name}}</div>
                    <div><strong>Drawing Area:</strong> Restricted to country boundaries</div>
                    <div><strong>Map Movement:</strong> Limited to country area</div>
                    <div><strong>Location Check:</strong> Only locations within {{selectedCountry.name}} are allowed</div>
                </div>
            </div>
            
            <!-- Overlap Detection Info -->
            <div *ngIf="polygons.length > 0" class="mt-3 p-3 bg-green-50 border-round border-1 border-green-200">
                <div class="flex items-center gap-2 mb-2">
                    <i class="pi pi-check-circle text-green-600"></i>
                    <span class="font-medium text-green-800">Overlap Detection Active</span>
                </div>
                <div class="text-sm text-green-700 space-y-1">
                    <div><strong>Polygons:</strong> {{polygons.length}} drawn</div>
                    <div><strong>Overlap Prevention:</strong> Enabled</div>
                    <div><strong>Edit Mode:</strong> {{editMode ? 'ON' : 'OFF'}}</div>
                    <div *ngIf="editMode"><strong>Editing:</strong> {{hasEditingPolygons() ? 'Active' : 'Ready'}}</div>
                </div>
            </div>
        </p-card>

        <!-- Location Check Result -->
        <p-card header="Location Check Result" styleClass="mb-3" *ngIf="locationCheckResult">
            <div class="space-y-3">
                <div class="flex items-center gap-2">
                    <i class="pi pi-map-marker text-primary"></i>
                    <span class="font-medium">Location:</span>
                    <span class="text-sm">{{locationCheckResult.location}}</span>
                </div>
                <div class="flex items-center gap-2">
                    <i class="pi pi-globe text-primary"></i>
                    <span class="font-medium">Coordinates:</span>
                    <span class="text-sm bg-gray-100 px-2 py-1 rounded">
                        {{locationCheckResult.coordinates.lat | number:'1.6-6'}}, 
                        {{locationCheckResult.coordinates.lng | number:'1.6-6'}}
                    </span>
                </div>
                <div class="flex items-center gap-2">
                    <i class="pi pi-check-circle" [class]="locationCheckResult.isInsidePolygon ? 'text-green-500' : 'text-red-500'"></i>
                    <span class="font-medium">Status:</span>
                    <span class="text-sm" [class]="locationCheckResult.isInsidePolygon ? 'text-green-600' : 'text-red-600'">
                        {{locationCheckResult.isInsidePolygon ? 'Inside Polygon' : 'Outside All Polygons'}}
                    </span>
                </div>
                <div *ngIf="locationCheckResult.containingPolygon" class="flex items-center gap-2">
                    <i class="pi pi-shield text-primary"></i>
                    <span class="font-medium">Containing Polygon:</span>
                    <span class="text-sm bg-blue-100 px-2 py-1 rounded">
                        {{locationCheckResult.containingPolygon.label || locationCheckResult.containingPolygon.id}}
                    </span>
                </div>
                <div *ngIf="locationCheckResult.googleInfo" class="pt-2">
                    <h6 class="font-medium mb-2">Google Information:</h6>
                    <div class="text-sm space-y-1">
                        <div><strong>Place ID:</strong> {{locationCheckResult.googleInfo.placeId}}</div>
                        <div><strong>Types:</strong> {{locationCheckResult.googleInfo.types?.join(', ')}}</div>
                    </div>
                </div>
                <div class="pt-2">
                    <p-button appGlobalLoadingDisable 
                        label="Clear Result" 
                        icon="pi pi-times" 
                        severity="secondary" 
                        size="small"
                        (onClick)="clearLocationCheck()" />
                </div>
            </div>
        </p-card>

        <!-- Selected Place Details -->
        <p-card header="Selected Place Details" styleClass="mb-3" *ngIf="selectedPlace">
            <div class="space-y-3">
                <div class="flex items-center gap-2">
                    <i class="pi pi-building text-primary"></i>
                    <span class="font-medium">Business ID:</span>
                    <span class="text-sm bg-gray-100 px-2 py-1 rounded">{{selectedPlace.place_id}}</span>
                </div>
                <div class="flex items-start gap-2">
                    <i class="pi pi-tag text-primary mt-1"></i>
                    <span class="font-medium">Name:</span>
                    <span class="text-sm">{{selectedPlace.name}}</span>
                </div>
                <div class="flex items-start gap-2">
                    <i class="pi pi-map-marker text-primary mt-1"></i>
                    <span class="font-medium">Address:</span>
                    <span class="text-sm">{{selectedPlace.formatted_address}}</span>
                </div>
                <div class="flex items-center gap-2">
                    <i class="pi pi-globe text-primary"></i>
                    <span class="font-medium">Coordinates:</span>
                    <span class="text-sm bg-gray-100 px-2 py-1 rounded">
                        {{selectedPlace.geometry?.location?.lat() | number:'1.6-6'}}, 
                        {{selectedPlace.geometry?.location?.lng() | number:'1.6-6'}}
                    </span>
                </div>
                <div class="pt-2">
                    <p-button appGlobalLoadingDisable 
                        label="Clear Selection" 
                        icon="pi pi-times" 
                        severity="secondary" 
                        size="small"
                        (onClick)="clearSelectedPlace()" />
                </div>
            </div>
        </p-card>

        <!-- Polygons List -->
        <p-card header="Polygons / Territories ({{polygons.length}})" styleClass="mb-3">
            <div class="space-y-3">
                <div *ngFor="let p of polygons" class="p-3 border-round border-1" 
                     [class]="p.isEditing ? 'surface-border border-green-300 bg-green-50' : 'surface-border'">
                    <div class="flex justify-content-between align-items-center mb-2">
                        <h6 class="m-0">{{p.label || 'Polygon'}} ({{p.id}})</h6>
                        <div *ngIf="p.isEditing" class="flex items-center gap-1">
                            <i class="pi pi-pencil text-green-600"></i>
                            <span class="text-xs text-green-600 font-medium">Editing</span>
                        </div>
                    </div>
                    
                    <!-- Validation Status -->
                    <div *ngIf="p.isEditing" class="mb-2">
                        <div *ngIf="validatePolygonEdit(p, p.path).isValid" class="text-xs text-green-600">
                            <i class="pi pi-check-circle mr-1"></i>Valid polygon
                        </div>
                        <div *ngIf="!validatePolygonEdit(p, p.path).isValid" class="text-xs text-red-600">
                            <i class="pi pi-exclamation-triangle mr-1"></i>{{validatePolygonEdit(p, p.path).message}}
                        </div>
                    </div>
                    
                    <div *ngIf="p.country" class="text-xs text-gray-600 mb-2">
                        <i class="pi pi-globe mr-1"></i>{{p.country}}
                    </div>
                    <div *ngIf="p.googleInfo" class="text-xs text-gray-600 mb-2">
                        <div><i class="pi pi-map-marker mr-1"></i>{{p.googleInfo.address}}</div>
                        <div><i class="pi pi-chart-area mr-1"></i>Area: {{p.googleInfo.area | number:'1.2-2':'de-DE'}} km²</div>
                    </div>
                    <div class="flex flex-wrap gap-2">
                        <p-button appGlobalLoadingDisable 
                            label="View" 
                            icon="pi pi-eye" 
                            severity="info" 
                            size="small"
                            (onClick)="onPolygonClick(p)" />
                        <p-button appGlobalLoadingDisable 
                            [label]="p.isEditing ? 'Stop Editing' : 'Edit'" 
                            [icon]="p.isEditing ? 'pi pi-stop' : 'pi pi-pencil'" 
                            [severity]="p.isEditing ? 'danger' : 'warn'" 
                            size="small"
                            (onClick)="p.isEditing ? stopEditingPolygon(p) : editPolygon(p)" />
                        <p-button appGlobalLoadingDisable 
                            label="Delete" 
                            icon="pi pi-trash" 
                            severity="danger" 
                            size="small"
                            (onClick)="removePolygon(p.id)" />
                    </div>
                </div>
            </div>
        </p-card>
    </div>

    <div class="map">
        <google-map #mapRef [center]="center" [zoom]="zoom" [options]="options" height="1000px" width="100%">
            <!-- Country Boundary -->
            <map-rectangle 
                *ngIf="showCountryBoundary && selectedCountry"
                [bounds]="selectedCountry.bounds"
                [options]="{
                    fillColor: 'transparent',
                    strokeColor: '#3B82F6',
                    strokeWeight: 3,
                    strokeOpacity: 0.8,
                    fillOpacity: 0.1
                }">
            </map-rectangle>
            
            <map-polygon 
                *ngFor="let poly of polygons" 
                [paths]="poly.path" 
                (mapClick)="onPolygonClick(poly)"
                [options]="{
                    fillColor: poly.isEditing ? '#00FF00' : '#FF0000',
                    fillOpacity: 0.3,
                    strokeColor: poly.isEditing ? '#00FF00' : '#FF0000',
                    strokeWeight: poly.isEditing ? 3 : 2,
                    editable: false,
                    draggable: false
                }">
            </map-polygon>
            
            <!-- Search location marker -->
            <map-marker 
                *ngIf="searchLocationMarker"
                [position]="searchLocationMarker"
                [options]="{
                    icon: {
                        url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
                    },
                    title: 'Searched Location'
                }">
            </map-marker>
        </google-map>
    </div>
</div>